export enum CraVisitStatus {
  notApplicable = 1,
  missing = 2,
  verified = 3,
  notSpecified = 4,
}
